module.exports = __webpack_public_path__ + "img/renaud-capucon.6122b56c.jpg";